<div class="container-fluid"> 
    
    <div class="row">
    

    <div class="col-xl-3 col-lg-6 col-md-6 paddingLeftOut">
        <mat-card class="consumo-agua">
            <mat-card-header>
                <div class="container">
                    <div class="row cabecera">
                        <div class="col-10">
                            <mat-card-title>
                                <div class="container">
                                    <div class="row">{{ 'DEVICE.WATER_CONSUMPTION' | translate }}</div>
                                    <div class="row important-number"><h3>{{deviceDetail?.waterConsumption?.monthValue|NullFormat}}</h3></div>
                                    <div class="row medicion">L/{{ 'TIMEZONE.MONTH' | translate}}</div>
                                </div>
                            </mat-card-title>
                        </div>
                        <div class="col-2 icono">
                            <app-blue-icon name="water"></app-blue-icon>
                        </div>
                        <div class="col-6 datos-mes"><h5>{{deviceDetail?.waterConsumption?.yearValue|NullFormat}}</h5></div>
                        <div class="col-6 datos-año"><h5>{{deviceDetail?.waterConsumption?.accumulatedValue|NullFormat}}</h5></div>
                        <div class="col-6 medicion">L/{{ 'TIMEZONE.YEAR' | translate }}</div>
                        <div class="col-6 medicion-acu">{{ 'DEVICE.ACCUMULATED' | translate }}</div>
                    </div>
                </div>
            </mat-card-header>
        </mat-card>
    </div>
    
    <div class="col-xl-3 col-lg-6 col-md-6">
        <mat-card class="consumo-luz">
            <mat-card-header>
                <div class="container">
                    <div class="row cabecera">
                        <div class="col-10">
                            <mat-card-title>
                                <div class="container">
                                    <div class="row">{{ 'DEVICE.ELECTRIC_CONSUMPTION' | translate }}</div>
                                    <div class="row important-number"><h3>{{deviceDetail?.energyConsumption?.monthValue|NullFormat}}</h3></div>
                                    <div class="row medicion">W/{{ 'TIMEZONE.MONTH' | translate }}</div>
                                </div>
                            </mat-card-title>
                        </div>
                        <div class="col-2 icono">
                            <app-blue-icon name="light"></app-blue-icon>
                        </div>
                        <div class="col-6 datos-mes"><h5>{{deviceDetail?.energyConsumption?.yearValue|NullFormat}}</h5></div>
                        <div class="col-6 datos-año"><h5>{{deviceDetail?.energyConsumption?.accumulatedValue|NullFormat}}</h5></div>
                        <div class="col-6 medicion">W/{{ 'TIMEZONE.YEAR' | translate }}</div>
                        <div class="col-6 medicion-acu">{{ 'DEVICE.ACCUMULATED' | translate }}</div>
                    </div>
                </div>
            </mat-card-header>
        </mat-card>
    </div>  

    <div class="col-xl-3 col-lg-6 col-md-6">
        <mat-card class="consumo-gas">
            <mat-card-header>
                <div class="container">
                    <div class="row cabecera">
                        <div class="col-10">
                            <mat-card-title>
                                <div class="container">
                                    <div class="row">{{ 'DEVICE.GAS_CONSUMPTION' | translate }}</div>
                                    <div class="row important-number"><h3>{{deviceDetail?.gasConsumption?.monthValue|NullFormat}}</h3></div>  
                                    <div class="row medicion">M3/{{ 'TIMEZONE.MONTH' | translate }}</div>
                                </div>
                            </mat-card-title>
                        </div>
                        <div class="col-2 icono">
                            <app-blue-icon name="gas"></app-blue-icon>
                        </div>
                        <div class="col-6 datos-mes"><h5>{{deviceDetail?.gasConsumption?.yearValue|NullFormat}}</h5></div>
                        <div class="col-6 datos-año"><h5>{{deviceDetail?.gasConsumption?.accumulatedValue|NullFormat}}</h5></div>
                        <div class="col-6 medicion">M3/{{ 'TIMEZONE.YEAR' | translate }}</div>
                        <div class="col-6 medicion-acu">{{ 'DEVICE.ACCUMULATED' | translate }}</div>
                    </div>
                </div>
            </mat-card-header>
        </mat-card>
    </div>

    <div *ngIf="showProductivityCard" class="col-xl-3 col-lg-6 col-md-6 paddingRightOut">
        <mat-card class="produccion">
            <mat-card-header>
                <div class="container">
                    <div class="row cabecera">
                        <div class="col-10">
                            <mat-card-title>
                                <div class="container">
                                    <div class="row">{{ 'DEVICE.PRODUCTIVITY' | translate }}</div>
                                    <div class="row important-number"><h3>{{deviceDetail?.productivity?.monthValue|NullFormat}}</h3></div>  
                                    <div class="row medicion">UND/{{ 'TIMEZONE.MONTH' | translate }}</div>
                                </div>
                            </mat-card-title>
                        </div>
                        <div class="col-2 icono">
                            <app-blue-icon name="production"></app-blue-icon>
                        </div>
                        <div class="col-6 datos-mes"><h5>{{deviceDetail?.productivity?.yearValue|NullFormat}}</h5></div>
                        <div class="col-6 datos-año"><h5>{{deviceDetail?.productivity?.accumulatedValue|NullFormat}}</h5></div>
                        <div class="col-6 medicion">UND/{{ 'TIMEZONE.YEAR' | translate }}</div>
                        <div class="col-6 medicion-acu">{{ 'DEVICE.ACCUMULATED' | translate }}</div>
                    </div>
                </div>
            </mat-card-header>
        </mat-card>
    </div>

</div> 
</div>
